import React from "react";
import style from "./RightNavigation.module.css";
import PropertiesLayout from "./Components/PropertiesLayout";
import ThemesLayout from "../../components/IFormDesignerLayout/IFormDesignerComponents/Theme/ThemesLayout";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { useSelector } from "../../Redux";
import { useEffect } from "react";
import { useRef } from "react";
import { GetStateFromData } from "../CustomHooks/CustomHooks";

const RightNavigation = (props) => {
  const contexts = GetStateFromData(props.containerId);
  const {
    updateJson,
    propertyPinned,
    setOpenProperties,
    setToggleProperty,
    toggleProperty,
    selectedControl,
    isTableBackdropOpen,
    openMF
  } = contexts.contexts;
  const { updatedComponentInFormState, removeAndUpdateComponentInFormState } =
    updateJson;

  const handleClickAway = (e) => {
    // setTimeout(() => {
    const insideRightNav = e.target?.closest(`[id=rightnavigation_main_id]`);
    if(!document?.getElementById("pickListMF_Parent_MDM")){
      if(document?.activeElement?.getAttribute("properyof")!=="tab" && document?.activeElement?.getAttribute("id") !== 'input_controls_search_appform'){
        document.activeElement.blur();
      }
    }    
    const autocompleteRoot = document.querySelector('.MuiAutocomplete-root');    
    const clickedInsideAutocomplete = autocompleteRoot && document.getElementById('processMappingAutocomplete')
      e.stopPropagation();

      if (insideRightNav === null && !openMF && !isTableBackdropOpen && !clickedInsideAutocomplete) {
        //console.log('clickAway called!');
        if (propertyPinned === false) {
          setOpenProperties(false);
          setToggleProperty(false);
        //   window.callSpecifiedFunctions(
        //     { },
        //     "",
        //     "",
        //     true  
        // );
        }
       
      }
  
      if (
        selectedControl?.elem_type === "combo" ||
        selectedControl?.elem_type === "listbox"
      ) {
        if (
          selectedControl?.options?.length > 0 &&
          (selectedControl?.options?.[
            selectedControl?.options?.length - 1
          ]?.label?.includes("addedoption") ||
            selectedControl?.options?.[
              selectedControl?.options?.length - 1
            ]?.value?.includes("addedoption"))
        ) {
          selectedControl?.options?.pop();
          updatedComponentInFormState(selectedControl?.id, selectedControl);
        }
    }
  // }, 300)
  };

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={(e) => handleClickAway(e)}
    >
      <div
        id="rightnavigation_main_id"
        className={style.rightnavigationContainer}
        style={{zIndex:"4"}}
      >
        <PropertiesLayout
          containerId={props.containerId}
          formData={props.formData}
          subformState={props.subformState}
          selectedControl={props.selectedControl}
          themeJSONData={props.themeJSONData}
          //  changeLeftNavigationHeader={props.changeLeftNavigationHeader}
          showProperties={props.showProperties}
          hideProperties={props.hideProperties}
          applyChanges={(ev, saveOldState) =>
            props.applyChanges(ev, saveOldState)
          }
          changeUndoList={() => props.changeUndoList()}
          microFrontendData={props?.microFrontendData}
        />
        <ThemesLayout
          containerId={props.containerId}
          formData={props.formData}
          applyChanges={(ev, saveOldState) =>
            props.applyChanges(ev, saveOldState)
          }
        />
      </div>
    </ClickAwayListener>
  );
};

export default RightNavigation;
